export default __webpack_public_path__ + "static/media/dark-circle.9146c661.svg";